<template>
  <ViewBase>
    <router-view />
  </ViewBase>
</template>

<script>

import ViewBase from '@/components/ViewBase.vue';

export default {
  name: 'App',
  components: {
    ViewBase,
  },
}

</script>

<style>
@import "assets/styles/app.css";

:root {
  --caps-letter-spacing: 0;
}
</style>
